import React from 'react';
import { IBlock, IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { BasicBlock } from '../../../components/BasicBlock';
import { createBlock, t } from '../../../utils';

export type ISpacer = IBlockData<{
    'container-background-color'?: string;
    height?: string;
    padding?: string;
}>;

export const Spacer: IBlock<ISpacer> = createBlock({
    get name() {
        return t('Spacer');
    },
    type: BasicType.SPACER,
    create: (payload: any) => {
        const defaultData: ISpacer = {
            type: BasicType.SPACER,
            data: {
                value: {},
            },
            attributes: {
                height: '20px',
            },
            children: [],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.COLUMN, BasicType.HERO],
    render(params: any) {
        return <BasicBlock params={params} tag="mj-spacer" />;
    },
});
